import StarterKit from "@tiptap/starter-kit"

import type { Extensions } from "@tiptap/core"

// Paragraphs, line breaks and undo only: for text that is stored as plain text.
export const plainTextExtensions = (): Extensions => [
	StarterKit.configure({
		heading: false,
		bold: false,
		italic: false,
		strike: false,
		code: false,
		codeBlock: false,
		blockquote: false,
		bulletList: false,
		orderedList: false,
		listItem: false,
		horizontalRule: false,
	}),
]
